/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Board_Col_MethodInputs */

const en_analytics_board_col_method = /** @type {(inputs: Analytics_Board_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Method`)
};

const de_analytics_board_col_method = /** @type {(inputs: Analytics_Board_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Methode`)
};

const fr_analytics_board_col_method = /** @type {(inputs: Analytics_Board_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Méthode`)
};

const es_analytics_board_col_method = /** @type {(inputs: Analytics_Board_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Método`)
};

const it_analytics_board_col_method = /** @type {(inputs: Analytics_Board_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metodo`)
};

const nl_analytics_board_col_method = /** @type {(inputs: Analytics_Board_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Methode`)
};

const pl_analytics_board_col_method = /** @type {(inputs: Analytics_Board_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoda`)
};

const fi_analytics_board_col_method = /** @type {(inputs: Analytics_Board_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menetelmä`)
};

const da_analytics_board_col_method = /** @type {(inputs: Analytics_Board_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metode`)
};

const sv_analytics_board_col_method = /** @type {(inputs: Analytics_Board_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metod`)
};

/**
* | output |
* | --- |
* | "Method" |
*
* @param {Analytics_Board_Col_MethodInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_board_col_method = /** @type {((inputs?: Analytics_Board_Col_MethodInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Board_Col_MethodInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_board_col_method(inputs)
	if (locale === "fr") return fr_analytics_board_col_method(inputs)
	if (locale === "es") return es_analytics_board_col_method(inputs)
	if (locale === "it") return it_analytics_board_col_method(inputs)
	if (locale === "nl") return nl_analytics_board_col_method(inputs)
	if (locale === "pl") return pl_analytics_board_col_method(inputs)
	if (locale === "fi") return fi_analytics_board_col_method(inputs)
	if (locale === "da") return da_analytics_board_col_method(inputs)
	if (locale === "sv") return sv_analytics_board_col_method(inputs)
	return en_analytics_board_col_method(inputs)
});